import React from "react";
import Image from "../../assets/register-head.png";
import "./index.scss";

function TrackCard({ track }) {
  return (
    <div className="track-card">
      <div className="card-body">
        <img
          src={
            track.thumnil
              ? `https://golancer.tech/admin/file/${track?.thumnil}`
              : Image
          }
          crossorigin="anonymous"
        />
        <h2> {track.title} </h2>
        <h3> المدرب: {track.trainer} </h3>
      </div>
      <div className="card-footer">
        <span> متوسط </span>
        <span> 25 ديسمبر 2022 </span>
        <span> 3 أشهر </span>
      </div>
    </div>
  );
}

export default TrackCard;
